import { Grid, Stack, Typography } from '@mui/material';
import useStyles from '../../style/js-style/containers/suspension/AccountSuspendedStyle';
import i18next from 'i18next';
import React from 'react';
import MenuAppBar from '../../components/MenuAppBar';
import EABackground from '../../components/EABackground';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const AccountSuspended = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      {/* Menu */}
      <MenuAppBar />

      {/* Header */}
      <EABackground />
      <Stack spacing={2} alignItems="center" className={classes.content}>
        <WarningAmberIcon color="warning" className={classes.icon} />
        <Typography variant={'h1'}>
          {i18next.t('suspension.mainTitle')}
        </Typography>
        <Grid item xs={10}>
          <Typography variant={'h2'} className={classes.title}>
            {i18next.t('suspension.title')}
          </Typography>
        </Grid>
      </Stack>
    </div>
  );
};

export default AccountSuspended;
